module.exports = __webpack_public_path__ + "static/img/logo2.f42cc13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2.png
// module id = 294
// module chunks = 0 1 2 3 4 5 6 7 8 9